import { render, staticRenderFns } from "./ModalServicesDeleted.vue?vue&type=template&id=2397d222"
import script from "./ModalServicesDeleted.vue?vue&type=script&lang=js"
export * from "./ModalServicesDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports